'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { apiClient } from '@/shared/lib/api';

/**
 * Syncs the current next-intl locale to the API client's Accept-Language header.
 * Without this, unauthenticated API requests fall back to GeoIP locale detection,
 * which may differ from the UI language.
 */
export function ApiLocaleSync() {
  const locale = useLocale();

  useEffect(() => {
    apiClient.setLocale(locale);
  }, [locale]);

  return null;
}
